// System dependencies

import { configureStore } from "@reduxjs/toolkit";

// Application dependencies

import auth from "@/_auth/redux/auth/auth.slices";
import authorisation from "@/redux/authorisation/authorisation.slices";
import formError from "@/redux/formError/formError.slices";
import formSpinner from "@/redux/formSpinner/formSpinner.slices";
import user from "@/redux/user/user.slices";

const store = configureStore({
  reducer: {
    auth,
    authorisation,
    formError,
    formSpinner,
    user,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export default store;
